import { render, staticRenderFns } from "./ChatGptConfigModal.vue?vue&type=template&id=ff852588&"
import script from "./ChatGptConfigModal.vue?vue&type=script&lang=js&"
export * from "./ChatGptConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatGptConfigModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/ChatGptConfigModal.vue
// module id = 2322
// module chunks = 1